import { render, staticRenderFns } from "./NumberTest.vue?vue&type=template&id=02115d95&scoped=true&"
import script from "./NumberTest.vue?vue&type=script&lang=js&"
export * from "./NumberTest.vue?vue&type=script&lang=js&"
import style0 from "./NumberTest.vue?vue&type=style&index=0&id=02115d95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02115d95",
  null
  
)

export default component.exports